/* Name Studio -- personalised EXILE cases.
   Three designs. The customer picks a design and types a name (up to
   CFG.maxChars). Each design starts the name in its own font, colour and
   spot; the customer can then change the font and colour, drag the name
   anywhere on the case and resize it. The direction stays the design's.
   The same drawing makes the preview and the print files sent with the
   order. */
(function(){
"use strict";
var ROOT = document.getElementById("case-studio");
var CFG_EL = document.getElementById("name-studio-config");
if (!ROOT || !CFG_EL) return;

var CFG = JSON.parse(CFG_EL.textContent);
var W = CFG.W, H = CFG.H;
var DESIGNS = CFG.designs;
/* Only the case styles the product actually sells (a style with no variant
   is left out), so removing a variant in the admin removes it here too. */
var CASES = CFG.cases.filter(function(c){ return c.variantId; });
if (!CASES.length) CASES = CFG.cases;
var FONTS = CFG.fonts || [], COLORS = CFG.colors || [];
var ALLOW = CFG.allow || { font:true, color:true, move:true };
var MAX = CFG.maxChars || 10;
var MODELS = CFG.models && CFG.models.length ? CFG.models : [
  "iPhone 17 Pro Max","iPhone 17 Pro","iPhone 17 Air","iPhone 17",
  "iPhone 16 Pro Max","iPhone 16 Pro","iPhone 16 Plus","iPhone 16",
  "iPhone 15 Pro Max","iPhone 15 Pro","iPhone 15 Plus","iPhone 15",
  "iPhone 14 Pro Max","iPhone 14 Pro","iPhone 14 Plus","iPhone 14",
  "iPhone 13 Pro Max","iPhone 13 Pro","iPhone 13"
];
/* Same rule as Case Studio: the 13 Pro only comes as Tough MagSafe. */
var MAGSAFE_ONLY = ["iphone 13 pro","iphone 18 pro max","iphone 18 pro"];
var SIZE_MIN = 50, SIZE_MAX = 170;   /* percent of the design's own size */

/* font/color null = the design's own. place null = the design's own spot;
   once moved it is the centre of the name, in fractions of the print box. */
var S = { design: DESIGNS[0].id, text: "", caseId: pickStart(), model: MODELS[0],
          font: null, color: null, place: null, rot: null, scale: 1 };
var ready = false, imgs = new Map(), view = { k:1 };
var INK = null;   /* where the name landed last draw, in print-box px */

var $ = function(s){ return ROOT.querySelector(s); };
var $$ = function(s){ return ROOT.querySelectorAll(s); };
var el = function(t,a,h){ var n=document.createElement(t); if(a) for(var k in a) n.setAttribute(k,a[k]); if(h!=null) n.innerHTML=h; return n; };
var esc = function(s){ return String(s).replace(/[&<>"']/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]; }); };
var clamp = function(v,a,b){ return Math.max(a, Math.min(b, v)); };
var _fmt = (function(){ try { return new Intl.NumberFormat(undefined,{style:"currency",currency:CFG.currencyCode}); } catch(e){ return null; } })();
var money = function(n){ return _fmt ? _fmt.format(n) : (CFG.currencyCode + " " + Number(n).toFixed(2)); };

function pickStart(){
  for (var i=0;i<CASES.length;i++) if (CASES[i].id === (CFG.startCase || "gold")) return CASES[i].id;
  return CASES[0].id;
}
function CC(){ for (var i=0;i<CASES.length;i++) if (CASES[i].id === S.caseId) return CASES[i]; return CASES[0]; }
function DD(){ for (var i=0;i<DESIGNS.length;i++) if (DESIGNS[i].id === S.design) return DESIGNS[i]; return DESIGNS[0]; }
function FF(id){ for (var i=0;i<FONTS.length;i++) if (FONTS[i].id === id) return FONTS[i]; return null; }
function magsafeOnly(){ return MAGSAFE_ONLY.indexOf(String(S.model).toLowerCase()) > -1; }

/* ---------- images ---------- */
function img(src){
  if (imgs.has(src)) return imgs.get(src);
  var im = new Image();
  im.crossOrigin = "anonymous";
  im.onload = function(){ render(); };
  im.src = src;
  imgs.set(src, im);
  return im;
}
function loaded(src){
  return new Promise(function(res){
    var im = img(src);
    if (im.complete && im.naturalWidth) return res(im);
    im.addEventListener("load", function(){ res(im); });
    im.addEventListener("error", function(){ res(im); });
  });
}
function ok(im){ return im && im.complete && im.naturalWidth; }

/* ---------- the name ---------- */
/* Letters (any alphabet), digits, spaces and the few marks that belong in a
   name. Emoji and symbols would print as a box, so they never get in. */
function clean(s){
  s = String(s || "").replace(/[^\p{L}\p{M}\p{N} &.'\-]/gu, "").replace(/\s+/g, " ");
  return Array.from(s).slice(0, MAX).join("");
}
/* The look in use: the design's own, with the customer's picks on top.
   Capitals and the trailing "." belong to a design's own font, so they go
   when another font is picked. */
function look(d){
  var f = (S.font && S.font !== d.fontId) ? FF(S.font) : null;
  return {
    own: !f,
    fontId: f ? f.id : d.fontId,
    font: f ? f.font : d.font,
    weight: f ? f.weight : d.weight,
    style: f ? f.style : d.style,
    k: f ? (f.k || 1) : 1,
    upper: f ? !!f.upper : !!d.upper,
    suffix: f ? "" : (d.suffix || ""),
    color: S.color || d.color,
    rot: (S.place && S.rot != null) ? S.rot : (d.rot || 0)
  };
}
function typed(){ return S.text.trim(); }
function textFor(d, L){
  var t = typed() || d.sample;
  if (L.upper) t = t.toUpperCase();
  return t + L.suffix;
}
function shown(d){ return textFor(d, look(d)); }
function fontOf(L, px){ return (L.style ? L.style + " " : "") + (L.weight ? L.weight + " " : "") + px + "px " + L.font; }
function fontLabel(d){
  var f = FF(look(d).fontId);
  return f ? f.label : String(look(d).font).split(",")[0].replace(/'/g, "");
}

/* Picking another font keeps the name about as tall as the design had it:
   both are measured on the actual name and the size scaled to match. */
var mctx = document.createElement("canvas").getContext("2d"), inkCache = {};
function inkH(L, text){
  var key = fontOf(L, 100) + "|" + text;
  if (inkCache[key]) return inkCache[key];
  mctx.font = fontOf(L, 100);
  var m = mctx.measureText(text || "Aa");
  var h = (m.actualBoundingBoxAscent || 70) + (m.actualBoundingBoxDescent || 0);
  var loadedFont = true;
  try { loadedFont = !document.fonts || document.fonts.check(fontOf(L, 100), text || "Aa"); } catch(e){}
  if (loadedFont) inkCache[key] = h;
  return h;
}
function sizeRatio(d, L){
  if (L.own) return 1;
  var dl = { font:d.font, weight:d.weight, style:d.style, upper:!!d.upper, suffix:d.suffix || "" };
  var r = inkH(dl, textFor(d, dl)) / Math.max(1, inkH(L, textFor(d, L)));
  return clamp(r * L.k, 0.4, 2.4);
}

/* ---------- drawing ---------- */
/* Everything is laid out in fractions of the case's print box, so the same
   design sits right on the tall Tough MagSafe face and the shorter lens
   cases alike. */
function drawDesign(x, b, d, text){
  /* background, covering the box */
  var bg = img(d.bg);
  if (ok(bg)){
    var s = Math.max(b.w/bg.naturalWidth, b.h/bg.naturalHeight);
    var dw = bg.naturalWidth*s, dh = bg.naturalHeight*s;
    x.drawImage(bg, (b.w-dw)/2, (b.h-dh)*(d.bgY == null ? 0.5 : d.bgY), dw, dh);
  } else {
    x.fillStyle = d.fill || "#888"; x.fillRect(0, 0, b.w, b.h);
  }
  /* the EXILE mark, spaced out the way the PSDs have it */
  if (d.logo !== false){
    var lp = 0.036*b.w, sp = 0.6*lp, LG = "EXILE", lw = 0, i;
    x.save();
    x.font = "500 " + lp + "px Archivo, sans-serif";
    x.fillStyle = d.logoColor || d.color;
    x.textBaseline = "alphabetic";
    for (i=0;i<LG.length;i++) lw += x.measureText(LG[i]).width + (i ? sp : 0);
    var cx = 0.5*b.w - lw/2;
    for (i=0;i<LG.length;i++){ x.fillText(LG[i], cx, 0.913*b.h); cx += x.measureText(LG[i]).width + sp; }
    x.restore();
  }
  drawName(x, b, d, text);
}

function drawName(x, b, d, text){
  var L = look(d), moved = !!S.place;
  var rot = L.rot, rad = rot*Math.PI/180;
  var across = Math.abs(rot) % 180 === 0;
  var px = d.size*b.w*sizeRatio(d, L)*S.scale;
  x.save();
  x.textAlign = moved ? "left" : (d.align || "left");
  x.textBaseline = "alphabetic";
  x.font = fontOf(L, px);
  var m = x.measureText(text);
  var inkW = m.actualBoundingBoxLeft + m.actualBoundingBoxRight;
  var inkHt = m.actualBoundingBoxAscent + m.actualBoundingBoxDescent;
  /* shrink to fit: along its lane, and across the case's other side */
  var lane = (moved ? 0.9 : d.max) * (across ? b.w : b.h);
  var cross = 0.9 * (across ? b.h : b.w);
  var f = Math.min(1, lane/Math.max(1, inkW), cross/Math.max(1, inkHt));
  if (f < 1){
    px *= f; x.font = fontOf(L, px);
    m = x.measureText(text);
    inkW = m.actualBoundingBoxLeft + m.actualBoundingBoxRight;
    inkHt = m.actualBoundingBoxAscent + m.actualBoundingBoxDescent;
  }
  var cxB, cyB, hx = (across ? inkW : inkHt)/2, hy = (across ? inkHt : inkW)/2;
  if (moved){
    /* keep the whole name on the case */
    var mg = 0.03*b.w;
    var mx0 = hx + mg, mx1 = b.w - hx - mg, my0 = hy + mg, my1 = b.h - hy - mg;
    cxB = mx0 > mx1 ? b.w/2 : clamp(S.place.cx*b.w, mx0, mx1);
    cyB = my0 > my1 ? b.h/2 : clamp(S.place.cy*b.h, my0, my1);
    S.place.cx = cxB/b.w; S.place.cy = cyB/b.h;
    x.translate(cxB, cyB);
    x.rotate(rad);
    x.fillStyle = L.color;
     x.globalAlpha = 1;   /* the sample reads as a placeholder */
    x.fillText(text, -inkW/2 + m.actualBoundingBoxLeft, (m.actualBoundingBoxAscent - m.actualBoundingBoxDescent)/2);
  } else {
    var ax = d.ax*b.w, ay = d.ay*b.h;
    var lcx = (m.actualBoundingBoxRight - m.actualBoundingBoxLeft)/2;
    var lcy = (m.actualBoundingBoxDescent - m.actualBoundingBoxAscent)/2;
    cxB = ax + lcx*Math.cos(rad) - lcy*Math.sin(rad);
    cyB = ay + lcx*Math.sin(rad) + lcy*Math.cos(rad);
    x.translate(ax, ay);
    x.rotate(rad);
    x.fillStyle = L.color;
      x.globalAlpha = 1;
    x.fillText(text, 0, 0);
  }
  x.restore();
  INK = { cx:cxB, cy:cyB, w:inkW, h:inkHt, rot:rot };
}

function paint(ctx, scale){
  var C = CC(), b = C.box, d = DD();
  ctx.setTransform(1,0,0,1,0,0);
  ctx.clearRect(0,0,W*scale,H*scale);
  ctx.save();
  ctx.scale(scale,scale);
  ctx.translate(b.x,b.y);
  ctx.beginPath(); ctx.rect(0,0,b.w,b.h); ctx.clip();
  drawDesign(ctx, b, d, shown(d));
  ctx.restore();
  var mk = img(C.mask);
  if (ok(mk)){
    ctx.globalCompositeOperation = "destination-in";
    ctx.drawImage(mk, 0, 0, W*scale, H*scale);
    ctx.globalCompositeOperation = "source-over";
  }
}

var art = $("#art"), actx = art.getContext("2d"), raf = false;
function render(){
  if (!ready || raf) return;
  raf = true;
  requestAnimationFrame(function(){ raf = false; paint(actx, art._s || 1); outline(); });
}

function layout(){
  var wrap = $("#stageWrap");
  var phone = window.matchMedia && window.matchMedia("(max-width:900px)").matches;
  var aw = wrap.clientWidth - (phone ? 24 : 70), ah = wrap.clientHeight - (phone ? 40 : 44);
  view.k = Math.min(aw/W, ah/H) * (phone ? 1 : (CFG.fit || 1));
  var dev = $("#device"), inner = $("#deviceInner"), k = view.k;
  dev.style.width = (W*k) + "px"; dev.style.height = (H*k) + "px";
  inner.style.width = W + "px"; inner.style.height = H + "px";
  inner.style.transform = "scale(" + k + ")";
  var dpr = Math.min(window.devicePixelRatio || 1, 2.5);
  var pw = Math.max(1, Math.round(W*k*dpr)), ph = Math.max(1, Math.round(H*k*dpr));
  if (art.width !== pw || art.height !== ph){ art.width = pw; art.height = ph; }
  art._s = pw / W;
}
function applyCase(){ $("#mock").src = CC().img; }
function refresh(){ applyCase(); layout(); render(); rail(); }

/* ---------- moving the name ---------- */
/* Drag anywhere on the case: the name follows the finger, so even a small
   name is easy to move on a phone. A tap without moving goes to the name box. */
var ov = $("#overlay");
ov.setAttribute("viewBox", "0 0 " + W + " " + H);
ov.setAttribute("width", W); ov.setAttribute("height", H);
var showBox = false, boxTimer = 0;
function outline(){
  if (!INK || !showBox){ ov.innerHTML = ""; return; }
  var b = CC().box, pad = 0.025*b.w;
  var cx = b.x + INK.cx, cy = b.y + INK.cy, w = INK.w + pad*2, h = INK.h + pad*2;
  var r = 'x="' + (cx - w/2) + '" y="' + (cy - h/2) + '" width="' + w + '" height="' + h + '" rx="' + pad + '" transform="rotate(' + INK.rot + ' ' + cx + ' ' + cy + ')" fill="none"';
  ov.innerHTML = '<rect ' + r + ' stroke="rgba(0,0,0,.45)" stroke-width="5"/><rect ' + r + ' stroke="#fff" stroke-width="2.5" stroke-dasharray="10 7"/>';
}
function flashBox(ms){
  showBox = true; outline();
  clearTimeout(boxTimer);
  if (ms) boxTimer = setTimeout(function(){ showBox = false; outline(); }, ms);
}
/* Freeze the design's spot as a centre point the first time the customer
   moves, turns or resizes the name, so it carries on from where it was. */
function detach(){
  if (S.place || !INK) return;
  var b = CC().box;
  S.place = { cx: INK.cx/b.w, cy: INK.cy/b.h };
  S.rot = DD().rot || 0;
}
function boxPoint(ev){
  var r = $("#deviceInner").getBoundingClientRect(), b = CC().box;
  return { x: (ev.clientX - r.left)/r.width*W - b.x, y: (ev.clientY - r.top)/r.height*H - b.y };
}
var stage = $("#stage"), drag = null;
if (!ALLOW.move) stage.style.cursor = "text";
stage.addEventListener("pointerdown", function(ev){
  if (ev.button) return;
  drag = { id:ev.pointerId, sx:ev.clientX, sy:ev.clientY, moved:false, p0:boxPoint(ev), start:null };
});
stage.addEventListener("pointermove", function(ev){
  if (!drag || ev.pointerId !== drag.id) return;
  if (!drag.moved){
    if (Math.hypot(ev.clientX - drag.sx, ev.clientY - drag.sy) < 5) return;
    if (!ALLOW.move){ drag = null; return; }
    drag.moved = true;
    detach();
    if (!S.place){ drag = null; return; }
    drag.start = { cx:S.place.cx, cy:S.place.cy };
    try { stage.setPointerCapture(ev.pointerId); } catch(e){}
    showBox = true; clearTimeout(boxTimer);
    ROOT.classList.add("ns-dragging");
  }
  var b = CC().box, p = boxPoint(ev);
  S.place.cx = drag.start.cx + (p.x - drag.p0.x)/b.w;
  S.place.cy = drag.start.cy + (p.y - drag.p0.y)/b.h;
  render();
});
function endDrag(ev){
  if (!drag || (ev && ev.pointerId !== drag.id)) return;
  var wasMoved = drag.moved;
  drag = null;
  ROOT.classList.remove("ns-dragging");
  if (wasMoved){ flashBox(900); rail(); }
  else if (ev && ev.type === "pointerup"){ var i = $("#nameIn"); if (i) i.focus({ preventScroll:true }); }
}
stage.addEventListener("pointerup", endDrag);
stage.addEventListener("pointercancel", endDrag);
stage.addEventListener("pointerenter", function(ev){ if (ev.pointerType === "mouse" && ALLOW.move){ showBox = true; outline(); } });
stage.addEventListener("pointerleave", function(ev){ if (ev.pointerType === "mouse" && !drag){ showBox = false; outline(); } });

/* ---------- rail ---------- */
function buildDesigns(){
  var box = $("#designBox");
  box.innerHTML = "";
  DESIGNS.forEach(function(d){
    var b = el("button", { class:"ns-design", type:"button", "data-d":d.id, "aria-label":d.name });
    var t = el("span", { class:"ns-design__t" });
    t.style.backgroundImage = "url(" + d.bg + ")";
    var s = el("span", { class:"ns-design__s" });
    s.textContent = d.upper ? d.sample.toUpperCase() : d.sample;
    s.style.fontFamily = d.font;
    if (d.weight) s.style.fontWeight = d.weight;
    s.style.color = d.color;
    if (d.rot) s.style.transform = "rotate(" + d.rot + "deg)";
    t.appendChild(s);
    b.appendChild(t);
    b.appendChild(el("span", { class:"ns-design__n" }, esc(d.name)));
    /* a new design starts the name in that design's spot */
    b.onclick = function(){
      if (S.design === d.id) return;
      S.design = d.id; S.place = null; S.rot = null; S.scale = 1;
      refresh();
    };
    box.appendChild(b);
  });
}
function buildName(){
  var inp = $("#nameIn");
  inp.setAttribute("maxlength", String(MAX + 4));
  inp.addEventListener("input", function(){
    var c = clean(inp.value);
    if (c !== inp.value){
      var at = inp.selectionStart;
      inp.value = c;
      try { inp.setSelectionRange(Math.min(at, c.length), Math.min(at, c.length)); } catch(e){}
    }
    S.text = c;
    $("#nameMsg").hidden = true;
    render(); rail();
  });
}
function buildFonts(){
  var sec = $("#fontSec"), box = $("#fontBox");
  if (!sec || !box) return;
  if (!ALLOW.font || !FONTS.length){ sec.hidden = true; return; }
  box.innerHTML = "";
  FONTS.forEach(function(f){
    var b = el("button", { class:"ns-font", type:"button", "data-f":f.id, "aria-label":f.label });
    var s = el("span", { class:"ns-font__s" });
    s.style.fontFamily = f.font;
    if (f.weight) s.style.fontWeight = f.weight;
    if (f.style) s.style.fontStyle = f.style;
    b.appendChild(s);
    b.appendChild(el("span", { class:"ns-font__n" }, esc(f.label)));
    b.onclick = function(){
      S.font = (f.id === DD().fontId) ? null : f.id;
      if (document.fonts && document.fonts.load){
        document.fonts.load(fontOf(look(DD()), 60), shown(DD())).then(function(){ inkCache = {}; render(); }).catch(function(){});
      }
      render(); rail();
    };
    box.appendChild(b);
  });
}
function buildColors(){
  var sec = $("#colorSec"), box = $("#colorBox");
  if (!sec || !box) return;
  if (!ALLOW.color){ sec.hidden = true; return; }
  box.innerHTML = "";
  var own = el("button", { class:"ns-sw ns-sw--own", type:"button", "data-col":"", "aria-label":"Original colour", title:"Original" });
  own.onclick = function(){ S.color = null; render(); rail(); };
  box.appendChild(own);
  COLORS.forEach(function(c){
    var b = el("button", { class:"ns-sw", type:"button", "data-col":c.hex.toLowerCase(), "aria-label":c.name, title:c.name });
    b.style.background = c.hex;
    b.onclick = function(){ S.color = c.hex.toLowerCase(); render(); rail(); };
    box.appendChild(b);
  });
  var pick = el("label", { class:"ns-sw ns-sw--pick", title:"Any colour" });
  var inp = el("input", { type:"color", "aria-label":"Pick any colour" });
  inp.addEventListener("input", function(){ S.color = inp.value.toLowerCase(); render(); rail(); });
  pick.appendChild(inp);
  box.appendChild(pick);
}
function buildPlace(){
  var sec = $("#placeSec");
  if (!sec) return;
  if (!ALLOW.move){ sec.hidden = true; return; }
  var r = $("#sizeIn");
  r.min = SIZE_MIN; r.max = SIZE_MAX; r.step = 1;
  r.addEventListener("input", function(){
    S.scale = (+r.value)/100;
    flashBox(900); render(); railPlace();
  });
  $("#placeReset").onclick = function(){
    S.place = null; S.rot = null; S.scale = 1;
    flashBox(900); render(); rail();
  };
}
function buildModels(){
  var host = $("#modelBox");
  host.innerHTML =
    '<div class="cs-model-wrap"><select id="modelSel" class="cs-model" aria-label="Phone model">' +
      MODELS.map(function(m){ return '<option value="' + esc(m) + '">' + esc(m) + '</option>'; }).join("") +
    '</select></div><div class="cs-note" id="modelNote"></div>';
  $("#modelSel").onchange = function(ev){
    S.model = ev.target.value;
    if (magsafeOnly()) S.caseId = "magsafe";
    buildCases(); refresh();
  };
}
function buildCases(){
  var box = $("#caseSeg");
  box.innerHTML = "";
  CASES.forEach(function(c){
    if (magsafeOnly() && c.id !== "magsafe") return;
    var b = el("button", { class:"case-opt", type:"button", "data-c":c.id });
    var crop = el("div", { class:"case-crop" });
    crop.style.backgroundImage = "url(" + c.img + ")";
    crop.style.backgroundPosition = c.crop;
    b.appendChild(crop);
    b.appendChild(el("div", { class:"case-name" }, esc(c.name)));
    b.onclick = function(){ S.caseId = c.id; refresh(); };
    box.appendChild(b);
  });
}
/* wide fonts shrink to fit their tile instead of being cut off */
function fitTile(s){
  s.style.fontSize = "";
  var avail = s.parentNode.clientWidth - 10, w = s.scrollWidth;
  if (avail > 0 && w > avail) s.style.fontSize = Math.max(10, 21*avail/w) + "px";
}
function fitTiles(){ Array.prototype.forEach.call($$("#fontBox .ns-font__s"), fitTile); }
function railPlace(){
  if (!ALLOW.move || !$("#placeSec")) return;
  var pct = Math.round(S.scale*100);
  $("#sizeIn").value = pct;
  $("#sizeVal").textContent = pct + "%";
  $("#placeReset").disabled = !S.place && S.scale === 1;
}
function rail(){
  var C = CC(), d = DD(), L = look(d);
  Array.prototype.forEach.call($$("#designBox .ns-design"), function(b){ b.setAttribute("aria-pressed", String(b.getAttribute("data-d") === S.design)); });
  Array.prototype.forEach.call($$("#caseSeg .case-opt"), function(b){ b.setAttribute("aria-pressed", String(b.getAttribute("data-c") === S.caseId)); });
  /* font tiles spell out the customer's own name */
  var word = typed() || d.sample;
  Array.prototype.forEach.call($$("#fontBox .ns-font"), function(b){
    b.setAttribute("aria-pressed", String(b.getAttribute("data-f") === L.fontId));
    var s = b.querySelector(".ns-font__s"); if (s.textContent !== word){ s.textContent = word; fitTile(s); }
    var n = b.querySelector(".ns-font__n");
    var f = FF(b.getAttribute("data-f"));
    n.textContent = (f && f.id === d.fontId) ? "Original" : (f ? f.label : "");
  });
  var own = $("#colorBox .ns-sw--own");
  if (own) own.style.background = d.color;
  var cur = (S.color || "").toLowerCase(), listed = !S.color;
  Array.prototype.forEach.call($$("#colorBox .ns-sw[data-col]"), function(b){
    var on = b.getAttribute("data-col") === cur;
    if (on) listed = true;
    b.setAttribute("aria-pressed", String(on));
  });
  var pick = $("#colorBox .ns-sw--pick");
  if (pick){
    pick.setAttribute("aria-pressed", String(!listed));
    pick.style.setProperty("--pick", listed ? "transparent" : cur);
    var pi = pick.querySelector("input"); if (pi) pi.value = /^#[0-9a-f]{6}$/.test(L.color.toLowerCase()) ? L.color.toLowerCase() : "#ffffff";
  }
  railPlace();
  var sel = $("#modelSel"); if (sel && sel.value !== S.model) sel.value = S.model;
  $("#crumbTitle").textContent = d.name;
  $("#priceOut").textContent = money(C.price);
  $("#footName").textContent = C.name + " case";
  $("#footPrice").textContent = money(C.price);
  $("#nameCount").textContent = Array.from(S.text).length + " / " + MAX;
  $("#nameIn").placeholder = "e.g. " + d.sample;
  var note = $("#modelNote");
  if (note) note.textContent = (magsafeOnly() && CASES.length > 1) ? ("The " + S.model + " is available in Tough MagSafe only.") : "";
  var h = $("#stageHint");
  if (h) h.textContent = !typed() ? "Type your name to see it on the case"
                       : (ALLOW.move ? "Drag the name to move it" : "Your " + d.name + " case");
}

/* ---------- export ---------- */
function exportPrint(scale, masked){
  var C = CC(), b = C.box;
  var c = document.createElement("canvas");
  c.width = Math.round(b.w*scale); c.height = Math.round(b.h*scale);
  var x = c.getContext("2d");
  x.save(); x.scale(scale, scale);
  drawDesign(x, b, DD(), shown(DD()));
  x.restore();
  if (masked === false) return c;
  var mk = img(C.mask);
  if (ok(mk)){
    var ms = mk.naturalWidth / W;
    x.globalCompositeOperation = "destination-in";
    x.drawImage(mk, b.x*ms, b.y*ms, b.w*ms, b.h*ms, 0, 0, c.width, c.height);
    x.globalCompositeOperation = "source-over";
  }
  return c;
}
function previewCanvas(){
  var pw = 620, ph = Math.round(620*H/W), k = pw/W;
  var c = document.createElement("canvas"); c.width = pw; c.height = ph;
  var x = c.getContext("2d");
  var base = img(CC().img);
  if (ok(base)) x.drawImage(base, 0, 0, pw, ph);
  var flat = document.createElement("canvas"); flat.width = pw; flat.height = ph;
  paint(flat.getContext("2d"), k);
  x.drawImage(flat, 0, 0);
  return c;
}
function toBlob(c){ return new Promise(function(res){ c.toBlob(res, "image/png"); }); }
function designState(){
  return { d:S.design, t:S.text, c:S.caseId, m:S.model, f:look(DD()).fontId, col:look(DD()).color,
           p:S.place ? { x:+S.place.cx.toFixed(4), y:+S.place.cy.toFixed(4), r:S.rot } : null, s:S.scale };
}
function designId(){
  var s = JSON.stringify(designState()) + Date.now();
  var h = 0x811c9dc5;
  for (var i=0;i<s.length;i++){ h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193); }
  return (h>>>0).toString(16);
}

/* ---------- cart ---------- */
var DRAWER_SECTIONS = "cart-drawer,cart-icon-bubble";
var busy = false;
function addToCart(){
  if (busy) return;
  var d = DD(), C = CC();
  if (!typed()){
    var m = $("#nameMsg"); m.hidden = false;
    $("#nameIn").focus();
    return;
  }
  if (!C.variantId){ cartError("This case style has no variant set up yet."); return; }
  busy = true; ROOT.classList.add("cs-busy");
  var id = designId();
  var want = Math.min((C.mmW / 25.4) * CFG.printDpi / C.box.w, 3.4);
  var fonts = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
  var drawer = null;
  fonts.then(function(){
    return Promise.all([ toBlob(exportPrint(want)), toBlob(exportPrint(want, false)), toBlob(previewCanvas()) ]);
  }).then(function(parts){
    var fd = new FormData();
    fd.append("id", String(C.variantId));
    fd.append("quantity", "1");
    fd.append("sections", DRAWER_SECTIONS);
    fd.append("sections_url", window.location.pathname);
    fd.append("properties[Phone model]", S.model);
    fd.append("properties[Design]", d.name);
    fd.append("properties[Name]", shown(d));
    if (ALLOW.font) fd.append("properties[Font]", fontLabel(d) + (look(d).own ? " (original)" : ""));
    if (ALLOW.color) fd.append("properties[Colour]", S.color ? S.color.toUpperCase() : "Original");
    fd.append("properties[_design_id]", id);
    fd.append("properties[_design]", JSON.stringify(designState()));
    if (CFG.preorder) fd.append("properties[Delivery]", CFG.preorder);
    if (parts[0]) fd.append("properties[Artwork]", parts[0], "print-" + id + ".png");
    if (parts[1]) fd.append("properties[To print]", parts[1], "toprint-" + id + ".png");
    if (parts[2]) fd.append("properties[Preview]", parts[2], "preview-" + id + ".png");
    return fetch(CFG.routes.cartAdd, { method:"POST", body:fd, credentials:"same-origin", headers:{ "Accept":"application/json" } })
      .then(function(r){ return r.json().then(function(j){
        if (!r.ok) throw new Error(j.description || j.message || "Could not add to cart");
        if (j && j.sections) drawer = j;
      }); });
  }).then(function(){
    busy = false; ROOT.classList.remove("cs-busy");
    if (!openDrawer(drawer)) window.location.href = CFG.routes.cart;
  }).catch(function(err){
    busy = false; ROOT.classList.remove("cs-busy");
    cartError((err && err.message) ? err.message : String(err));
  });
}
function openDrawer(state){
  var host = document.querySelector("cart-drawer");
  if (!host || typeof host.renderContents !== "function") return false;
  if (!state || !state.sections || !state.sections["cart-drawer"]) return false;
  try { host.classList.remove("is-empty"); host.renderContents(state); return true; } catch(e){ return false; }
}
function cartError(msg){
  var m = $("#cartPayload");
  if (m) m.textContent = "Could not add to cart\n\n" + msg;
  $("#cartModal").classList.add("open");
}
Array.prototype.forEach.call($$("[data-close]"), function(b){ b.onclick = function(){ b.closest(".modal").classList.remove("open"); }; });
Array.prototype.forEach.call($$(".modal"), function(m){ m.addEventListener("click", function(e){ if (e.target === m) m.classList.remove("open"); }); });
$("#cartBtn").onclick = addToCart;
$("#cartBtn2").onclick = addToCart;

var rt;
window.addEventListener("resize", function(){ clearTimeout(rt); rt = setTimeout(function(){ layout(); render(); fitTiles(); }, 90); });

/* ---------- start ---------- */
buildDesigns(); buildName(); buildFonts(); buildColors(); buildPlace(); buildModels(); buildCases();
/* one case style: nothing to choose, so the picker is hidden */
if (CASES.length < 2){ var cs = $("#caseSeg"); if (cs && cs.closest("section")) cs.closest("section").hidden = true; }
var srcs = [];
CASES.forEach(function(c){ srcs.push(c.img, c.mask); });
DESIGNS.forEach(function(d){ srcs.push(d.bg); });
var fontLoads = DESIGNS.map(function(d){
  if (!document.fonts || !document.fonts.load) return Promise.resolve();
  return document.fonts.load(fontOf(d, 100), d.sample + " ABCabc").catch(function(){});
});
if (document.fonts && document.fonts.load) fontLoads.push(document.fonts.load("500 20px Archivo", "EXILE").catch(function(){}));
Promise.all(srcs.map(loaded).concat(fontLoads)).then(function(){ ready = true; refresh(); });
/* Paint something straight away; the fonts and art fill in as they land. */
setTimeout(function(){ if (!ready){ ready = true; refresh(); } }, 2500);
/* the other fonts load in the background so picking one is instant */
if (document.fonts && document.fonts.load) FONTS.forEach(function(f){ document.fonts.load(fontOf(f, 60), "Aa").catch(function(){}); });
if (document.fonts && document.fonts.addEventListener) document.fonts.addEventListener("loadingdone", function(){ inkCache = {}; render(); fitTiles(); });
})();
